import dayjs, { type Dayjs } from 'dayjs';
import type { IPaginationState } from 'src/utils/server-side-pagination';

export const DATE_PICKER_VALUE_FORMAT = 'YYYY-MM-DD';

export function formatDatePickerValue(value: Dayjs | null | undefined): string | null {
  return value ? value.format(DATE_PICKER_VALUE_FORMAT) : null;
}

function parseDatePickerValue(value: Dayjs | string | null | undefined): Dayjs | null {
  if (!value) {
    return null;
  }

  const parsedValue = dayjs.isDayjs(value) ? value : dayjs(value);

  return parsedValue.isValid() ? parsedValue : null;
}

function toUtcDateBoundaryIso(
  value: Dayjs | string | null | undefined,
  hours: number,
  minutes: number,
  seconds: number,
  milliseconds: number
): string | null {
  const parsedValue = parseDatePickerValue(value);

  if (!parsedValue) {
    return null;
  }

  return new Date(
    Date.UTC(
      parsedValue.year(),
      parsedValue.month(),
      parsedValue.date(),
      hours,
      minutes,
      seconds,
      milliseconds
    )
  ).toISOString();
}

export function toUtcStartOfDayIso(value: Dayjs | string | null | undefined): string | null {
  return toUtcDateBoundaryIso(value, 0, 0, 0, 0);
}

export function toUtcEndOfDayIso(value: Dayjs | string | null | undefined): string | null {
  return toUtcDateBoundaryIso(value, 23, 59, 59, 999);
}

export function withUtcIsoDateRangeState(state: IPaginationState): IPaginationState {
  const nextFilters = { ...state.filters };

  if (typeof nextFilters.startDate === 'string' && nextFilters.startDate) {
    nextFilters.startDate = toUtcStartOfDayIso(nextFilters.startDate);
  }

  if (typeof nextFilters.endDate === 'string' && nextFilters.endDate) {
    nextFilters.endDate = toUtcEndOfDayIso(nextFilters.endDate);
  }

  return {
    ...state,
    filters: nextFilters,
  };
}
